import {all, call, put, takeLeading} from 'redux-saga/effects';
import {actions, ActionType} from './action';
import {getGenres, getResult} from './apiGet';
import callApi from '../../common/util/api';
import {makeFetchSaga, IPagingParam} from '../../common/util/fetch';
import {callApiSearchResult} from '../../commonSub/state/callApi';

function* fetchGenres() {
  const {success, data} = yield call(callApi, {
    url: '/search/v1/genres',
  });
  if (success && data) {
    const genres = getGenres(data);
    yield put(actions.setValue('genres', genres));
  }
}

function* fetchSuggest(action: ReturnType<typeof actions.fetchSuggest>) {
  const {keyword} = action.payload;
  if (keyword) {
    const params = new URLSearchParams(`word=${keyword}`);
    const {success, data} = yield call(callApi, {
      url: '/search/v1/search/suggestions',
      params,
    });
    if (success && data) {
      yield put(
        actions.setPropertyValues('suggest', {
          [keyword]: Array.isArray(data) ? data : [],
        })
      );
    }
  }
}

function* fetchResult(
  action: ReturnType<typeof actions.fetchResult>,
  params: IPagingParam
) {
  const {success, data, meta} = yield call(
    callApiSearchResult,
    action.payload,
    params
  );
  if (success && data && meta) {
    const result = getResult(data, meta);
    yield put(actions.addResult(result, action.isFirst));
  }
}

export default function* saga() {
  yield all([
    takeLeading(
      ActionType.FetchGenres,
      makeFetchSaga({fetchSaga: fetchGenres, canCache: true})
    ),
    takeLeading(
      ActionType.FetchSuggest,
      makeFetchSaga({fetchSaga: fetchSuggest, canCache: true})
    ),
    takeLeading(
      ActionType.FetchResult,
      makeFetchSaga({fetchSaga: fetchResult, canCache: true})
    ),
  ]);
}
